import React, { Fragment, useCallback, useState } from "react";
import { Alert, Col, Row, Spinner } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { fetchCashFlowStatement } from "../../../api/accounting";
import { formatTZS } from "../../../utils/format";
import TablePageMetricCard from "../Common/TablePageMetricCard";
import { formatApiError, runLoad } from "../Common/credoraToast";
import AccountingReportFilters from "./AccountingReportFilters";
import { ACCOUNTING_SECTION } from "./accountingPlaceholders";
import { accountingReportBreadcrumbs } from "./accountingReportShell";
import { useAccountingReportFilters } from "./useAccountingReportFilters";

const CashFlowPage = ({ reportMode = false }) => {
  const crumbs = accountingReportBreadcrumbs({ reportMode, title: "Cash Flow Statement" });
  const filters = useAccountingReportFilters();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    return runLoad(() => fetchCashFlowStatement(filters.reportParams()).then(setData), {
      errorMessage: "Failed to load cash flow statement.",
    })
      .catch((err) => setError(formatApiError(err, "Failed to load cash flow statement.")))
      .finally(() => setLoading(false));
  }, [filters.reportParams]);

  return (
    <Fragment>
      <Breadcrumbs mainTitle={crumbs.mainTitle} parent={crumbs.parent} title={crumbs.title} />
      <div className={`container-fluid${reportMode ? " credora-finance-reports pb-5 mb-3" : ""}`}>
        {error && <Alert color="danger">{error}</Alert>}
        <AccountingReportFilters {...filters} onApply={load} loading={loading} />
        {loading ? (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        ) : data ? (
          <>
            <Row className="g-3 mb-3">
              <Col md="3"><TablePageMetricCard title="Opening cash" value={formatTZS(data.opening_cash)} /></Col>
              <Col md="3"><TablePageMetricCard title="Closing cash" value={formatTZS(data.closing_cash)} /></Col>
              <Col md="3"><TablePageMetricCard title="Net change" value={formatTZS(data.net_change)} /></Col>
              <Col md="3"><TablePageMetricCard title="Operating" value={formatTZS(data.operating_activities)} subtitle="Net income basis" /></Col>
            </Row>
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between py-2 border-bottom"><span>Operating activities</span><strong>{formatTZS(data.operating_activities)}</strong></div>
                <div className="d-flex justify-content-between py-2 border-bottom"><span>Investing activities</span><strong>{formatTZS(data.investing_activities)}</strong></div>
                <div className="d-flex justify-content-between py-2 border-bottom"><span>Financing activities</span><strong>{formatTZS(data.financing_activities)}</strong></div>
                <div className="d-flex justify-content-between py-2"><span>Net change in cash</span><strong>{formatTZS(data.net_change)}</strong></div>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </Fragment>
  );
};

export default CashFlowPage;
